import request from './request'

export const getCommunityAgentList = (params) => {
  return request({
    url: '/admin/community-agents',
    method: 'get',
    params
  })
}

export const createCommunityAgent = (data) => {
  return request({
    url: '/admin/community-agents',
    method: 'post',
    data
  })
}

export const updateCommunityAgent = (id, data) => {
  return request({
    url: `/admin/community-agents/${id}`,
    method: 'put',
    data
  })
}

export const deleteCommunityAgent = (id) => {
  return request({
    url: `/admin/community-agents/${id}`,
    method: 'delete'
  })
}
